export const CHECKOUT_URL = "https://wealth.jmuenz.com/abundance-machine/";
export const HERO_IMAGE = `${process.env.PUBLIC_URL || ""}/teaching-arms.png`;
export const FOUNDER_IMAGE = `${process.env.PUBLIC_URL || ""}/founder-laughing.webp`;
export const LIFESTYLE_IMAGE = `${process.env.PUBLIC_URL || ""}/coaching-table.png`;
export const RED_MIRROR_IMAGE = `${process.env.PUBLIC_URL || ""}/red-mirror.webp`;
export const GROUP_IMAGE = `${process.env.PUBLIC_URL || ""}/group-women.png`;
export const CIRCLE_IMAGE = `${process.env.PUBLIC_URL || ""}/circle-red.webp`;
export const LAKE_IMAGE = `${process.env.PUBLIC_URL || ""}/lake.webp`;
export const CRYSTALS_IMAGE = `${process.env.PUBLIC_URL || ""}/crystals.png`;
export const CABIN_IMAGE = `${process.env.PUBLIC_URL || ""}/retreat-cabin.png`;
export const LAUNCH_DATE_ISO = "2026-11-30T00:00:00-08:00";

export const cta = {
  hero: "LET'S DO THIS!",
  pitch: "I WANT MORE!",
  pricing: "GIMME THE ABUNDANCE MACHINE",
  final: "I'M READY TO RECEIVE",
};

export const visionList = [
  "Imagine opening your email and finding an opportunity you weren't expecting.",
  "Receiving a compliment, gift, or offer of support w/o immediately trying to give something back.",
  "Finally moving on an idea you've been sitting on for months.",
  "Feeling excited about what might happen today instead of thinking about everything you need to get done.",
  "Recognizing opportunities you might have overlooked before. And starting to notice you're becoming a woman who expects incredible things to happen for her.",
];

export const phases = [
  {
    days: "DAYS 1–7",
    title: "AWARENESS",
    subtitle: "What are you actually believing about abundance?",
    body: [
      "You might consciously believe there's unlimited money available to you.",
      "But what happens when someone wants to pay you more than you expected or when an opportunity comes along that feels almost too good..",
      "Or when you're enjoying a beautiful afternoon and suddenly feel like you should be doing something productive?",
      "We're exploring the beliefs and habitual patterns influencing how you receive money, support, opportunities and ease.",
      "You'll begin recognizing where your internal dialogue and automatic responses may be affecting your decisions.",
      "And you'll start practicing something different.",
    ],
  },
  {
    days: "DAYS 8–14",
    title: "RECALIBRATION",
    subtitle: "Let's change what you're practicing internally.",
    body: [
      "This is where we get into subconscious recoding, visualization, energy work and frequency practices.",
      "We'll work with the beliefs you want to strengthen and the emotional states you want to experience more often.",
      "Repetition matters and what you consistently think, practice and reinforce influences how you experience the world and respond to opportunities.",
      "We're going to make those practices intentional.",
    ],
  },
  {
    days: "DAYS 15–21",
    title: "THE ABUNDANCE MACHINE",
    subtitle: "Now let's see what happens…",
    body: [
      "This is where you're practicing receiving, asking for what you want and following your internal guidance system.",
      "Noticing where you're making different choices and documenting what unfolds.",
      "The goal is to develop a way of thinking, receiving and participating in your life that you want to continue.",
    ],
  },
];

export const included = [
  {
    title: "21 DAILY AUDIO EXPERIENCES",
    body: "Short, prerecorded practices designed to help you explore and strengthen new beliefs around abundance, receiving, opportunity, and possibility infused with subconscious recoding practices that help you work with internal beliefs and patterns that influence how you think, feel and behave.",
  },
  {
    title: "ENERGY + FREQUENCY PRACTICES",
    body: "The shortest daily exercises to make you aware of your emotional state to approach your life with greater self-trust.",
  },
  {
    title: "DAILY ABUNDANCE EXPERIMENTS",
    body: "Easy ways to bring what you're learning into real life.",
  },
  {
    title: "YOUR ABUNDANCE TRACKER",
    body: "A place to document what happens throughout the 21 days… we're keeping track of the money, opportunities, support, shifts and experiences that make you stop and think, “did that really just happen!?”",
  },
  {
    title: "COMPLETE FLEXIBILITY",
    body: "Everything is prerecorded and self-paced so you can listen while you're getting ready, walking, or making breakfast.",
  },
];

export const testimonials = [
  "I am now showing up with more clarity and conviction in my business and it feels so good!",
  "I trust that I know what's right and I say it effortlessly in my trainings and with my husband.",
  "I feel way more fierce in the way that I say things and the way that I create spaces for others.",
  "We cleaned that energy in 45 minutes and a 5K payment came in on the call!",
  "I'm standing in my own puddle of confidence explaining what I do, even to normies!",
  "Girl, being in that pocket of authority is coming through.",
];

export const founderStats = [
  { value: "14", label: "years working with the subconscious mind" },
  { value: "3", label: "multi-6 figure businesses created" },
  { value: "$115K", label: "month" },
  { value: "21", label: "digital programs created" },
  { value: "19", label: "sold out retreats led" },
  { value: "13+", label: "countries with clients" },
];

export const credentials = [
  "Certified Hypnotherapist",
  "Certified Therapist",
  "Certified Rapid Transformational Therapy (RTT) Therapist",
  "Trained in Rapid Resolution Therapy",
  "Certified Quantum Healer",
  "Ordained Mary Magdalene Priestess",
  "Reiki Level I & II Practitioner",
  "Certified Somatic Intuitive Facilitator",
  "Certified Integrative Holistic Health Coach through the Institute for Integrative Nutrition",
  "Certified Regenerative Detoxification Specialist",
  "Trained in NLP and cognitive behavioral techniques",
  "Certified Past Life Regressionist",
  "Additional training and experience in somatic and energy-based practices",
];

export const forHer = [
  "Loves exploring energy, frequency, subconscious beliefs and the connection between her internal and external worlds.",
  "Wants more money, opportunities, support, freedom and experiences w/o adding more work to her life.",
  "Is willing to look at the beliefs influencing her relationship with receiving.",
  "Wants to strengthen her trust in herself and her internal guidance system",
  "Is excited to try something new!!",
  "And loves the idea of spending 21 days seeing what happens when she becomes more intentional about what she's creating.",
];

export const faqs = [
  {
    q: "Do I need experience with manifestation or energy work?",
    a: "It isn’t the experience with it that matters, it’s do you believe that it works?",
  },
  {
    q: "How much time will this take?",
    a: "Like 15 minutes/day!",
  },
  {
    q: "Are there live calls?",
    a: "No. Everything is prerecorded and self-paced. You can participate wherever and whenever works for you.",
  },
  {
    q: "Is this only about money?",
    a: "No! We're exploring abundance in many forms, including money, opportunities, wellness and your relationship with receiving.",
  },
  {
    q: "What if I'm already successful?",
    a: "Then you'll love this. We're exploring how you can experience more of what you want.",
  },
  {
    q: "Will I manifest a specific amount of money?",
    a: "There are no guaranteed financial outcomes. The experience focuses on your beliefs, awareness, emotional patterns and intentional actions. You'll track what you notice and experience, but results will be different for everyone.",
  },
  {
    q: "Can I do this if I've never worked with you?",
    a: "Absolutely. This experience is designed to introduce you to my approach and guide you through the entire process.",
  },
];
